export default "__VITE_ASSET__DE6RFV5D__"